import { useCallback, useEffect, useState } from "react";
import AdminManagementLayout from "../components/admin/AdminManagementLayout";
import BriefingQueue from "../components/admin/BriefingQueue";
import DocumentAnalyticsPanel from "../components/admin/DocumentAnalyticsPanel";
import LeadPipeline from "../components/admin/LeadPipeline";
import LeadNotesManager from "../components/admin/LeadNotesManager";
import { API } from "../data/siteData";
import useAdminAccess from "../hooks/useAdminAccess";

export default function AdminOperationsPage() {
  const accessState = useAdminAccess();
  const [leads, setLeads] = useState([]);
  const [briefings, setBriefings] = useState([]);
  const [analytics, setAnalytics] = useState([]);
  const [state, setState] = useState("loading");

  const loadOperations = useCallback(async () => {
    try {
      const [leadsResponse, briefingsResponse, analyticsResponse] = await Promise.all([
        fetch(`${API}/admin/leads`, { credentials: "include" }),
        fetch(`${API}/admin/briefing-requests`, { credentials: "include" }),
        fetch(`${API}/admin/documents/analytics`, { credentials: "include" }),
      ]);
      if (!leadsResponse.ok || !briefingsResponse.ok || !analyticsResponse.ok) throw new Error();
      setLeads(await leadsResponse.json());
      setBriefings(await briefingsResponse.json());
      setAnalytics(await analyticsResponse.json());
      setState("ready");
    } catch {
      setState("error");
    }
  }, []);

  useEffect(() => {
    if (accessState === "ready") loadOperations();
  }, [accessState, loadOperations]);

  if (accessState === "loading" || state === "loading") return <main className="portal-state" data-testid="admin-operations-loading">Loading relationship operations…</main>;
  if (state === "error") return <main className="portal-state" data-testid="admin-operations-error">Relationship operations are temporarily unavailable.</main>;

  return (
    <AdminManagementLayout
      active="operations"
      eyebrow="Control Room operations"
      title="RELATIONSHIP DESK"
    >
      <LeadPipeline leads={leads} onRefresh={loadOperations} />
      <LeadNotesManager leads={leads} />
      <BriefingQueue requests={briefings} onRefresh={loadOperations} />
      <DocumentAnalyticsPanel analytics={analytics} />
    </AdminManagementLayout>
  );
}